<section class="desktop-configurator" [class.panel-collapsed]="panelCollapsed" [class.has-preview]="preview">
  <div class="desktop-configurator__workspace">
    <aside class="desktop-configurator__steps">
      @for (step of steps; track step.id) {
        <button
          type="button"
          class="desktop-configurator__step"
          [class.active]="step.id === currentStepId"
          [class.done]="isStepCompleted(step)"
          [disabled]="!canSelectStep(step)"
          (click)="selectStep(step)">
          <span>
            @if (isStepCompleted(step)) {
              &#10003;
            } @else {
              {{ $index + 1 }}
            }
          </span>
          <strong>{{ step.label }}</strong>
        </button>
      }
    </aside>

    <section class="desktop-configurator__panel">
      <header>
        <h2>{{ activeStep?.label }}</h2>
        @if (preview) {
          <button type="button" class="desktop-configurator__panel-toggle" aria-label="Fermer le panneau" (click)="togglePanel()">
            <span class="desktop-configurator__toggle-icon desktop-configurator__toggle-icon--left"></span>
          </button>
        }
      </header>
      <div class="desktop-configurator__panel-content">
        <ng-container #stepHost></ng-container>
      </div>
    </section>

    @if (panelCollapsed && preview) {
      <button type="button" class="desktop-configurator__open-panel" aria-label="Ouvrir le panneau" (click)="togglePanel()">
        <span class="desktop-configurator__toggle-icon desktop-configurator__toggle-icon--right"></span>
      </button>
    }
  </div>

  <section class="desktop-configurator__preview">
    <ng-container #previewHost></ng-container>
  </section>

  <aside class="desktop-configurator__actions">
    @for (action of actions; track action.id) {
      <button
        type="button"
        class="desktop-configurator__action"
        [class.primary]="action.primary"
        [disabled]="isActionDisabled(action)"
        (click)="runAction(action)">
        <span class="desktop-configurator__action-icon">
          @switch (action.icon) {
            @case ('save') {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 3h12l2 2v16H5V3Z" />
                <path d="M8 3v6h8V3" />
                <path d="M8 16h8v5H8v-5Z" />
              </svg>
            }
            @case ('percent') {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 5 5 19" />
                <circle cx="7.5" cy="7.5" r="2.5" />
                <circle cx="16.5" cy="16.5" r="2.5" />
              </svg>
            }
            @case ('arrow-right') {
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12h14" />
                <path d="m13 6 6 6-6 6" />
              </svg>
            }
            @default {
              @if (action.iconClass) {
                <i [class]="action.iconClass"></i>
              }
            }
          }
        </span>
        <span>{{ isActionLoading(action) ? 'Chargement...' : getActionLabel(action) }}</span>
      </button>
    }
  </aside>
</section>
